module.exports = __webpack_public_path__ + "static/img/产品解决方案_图4@2x.28a04c5f.png";